import { useState } from "react";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell as MUITableCell,
  TablePagination,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import formatDateTimeString from "./../../utils/formatDateTimeString.js"
import { useData } from "../../hooks/useData";

const TableCell = styled(MUITableCell)({
  overflowWrap: "anywhere",
  wordBreak: "normal"
});

const TableHeadCell = styled(MUITableCell)({
  paddingTop: 6,
  paddingRight: 0,
  paddingBottom: 6,
  paddingLeft: 16,
});

const ChangeRow = ({ updated_at, from, to, updated_by }) => (
  <TableRow hover>
    <TableCell>{formatDateTimeString(updated_at)}</TableCell>
    <TableCell>{from}</TableCell>
    <TableCell>{to}</TableCell>
    <TableCell>{updated_by}</TableCell>
  </TableRow>
);

const SkeletonRow = () => (
  <TableRow>
    <TableCell colspan={4}><Skeleton variant="text" /></TableCell>
  </TableRow>
);

const GlobalProgrammaticMarginHistoryList = ({ name }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { data, loading } = useData(
    "player",
    `/api/programmatic_supply/global_settings/${name}/history`,
    { page: page + 1, per_page: rowsPerPage }
  );

  const records = data?.records ?? [];
  const totalCount = data?.pagination?.total_count ?? 0;

  const handlePageChange = (_event, newPage) => setPage(newPage);
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setPage(0);
  };

  return (
    <Box style={{ style: "width: 100%" }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableHeadCell>Modified At</TableHeadCell>
              <TableHeadCell>Previous Value</TableHeadCell>
              <TableHeadCell>New Value</TableHeadCell>
              <TableHeadCell>Modified By</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? Array.from({ length: rowsPerPage }, (_, i) => <SkeletonRow key={i} />)
              : records.map((record) => (<ChangeRow {...record} key={record.version_id} />))
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={totalCount}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[10, 20, 50]}
        SelectProps={{ native: true }}
      />
    </Box>
  );
};

export default GlobalProgrammaticMarginHistoryList;
